export const WarningIconMarkup = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path fill-rule="evenodd" d="M12.865 3.495a1 1 0 0 0-1.73 0L1.868 19.499A1 1 0 0 0 2.734 21h18.531a1 1 0 0 0 .866-1.501L12.865 3.495zM12.5 9a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1zm0 7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1z" clip-rule="evenodd"/>
    </svg>`;

export const EdapInsuranceFailedEventkey = 'insurance_booking_failed';
